module.exports = __webpack_public_path__ + "img/charging1.9e1ddbdb.png";